module.exports = __webpack_public_path__ + "media/icon/icon-calender-white-2aee7a13.svg";